export default __webpack_public_path__ + "a6c89cf2c5c3978ea4671a28d7cee724.png";